export const IDLE_STATUS = "idle";
export const LOADING_STATUS = "loading";
export const SUCCESS_STATUS = "success";
export const FAILURE_STATUS = "failure";

export type StateStatus = typeof IDLE_STATUS | typeof LOADING_STATUS | typeof SUCCESS_STATUS | typeof FAILURE_STATUS;